import React from 'react';
import { processSteps } from '../../data/mock';
import { Check, ArrowRight } from 'lucide-react';

const ProcessSection = ({ type }) => {
  const steps = type === 'industries' ? processSteps.industries : processSteps.innovation;
  const sectionTitle = type === 'industries' 
    ? 'Our Process' 
    : 'How We Work';
  const sectionSubtitle = type === 'industries'
    ? 'A proven approach to delivering lasting results'
    : 'From discovery to funding approval';

  return (
    <section id="process" className="relative bg-black py-24 lg:py-32 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img 
          src="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=1920&q=80" 
          alt="" 
          className="w-full h-full object-cover opacity-5"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black via-transparent to-black" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-20">
          <span className="text-[#4A90A4] text-sm font-semibold uppercase tracking-wider mb-4 block">Our Approach</span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            {sectionTitle}
          </h2>
          <p className="text-white/60 text-lg">
            {sectionSubtitle}
          </p>
        </div>

        {/* Process Timeline */}
        <div className="relative">
          {/* Connecting Line */}
          <div className="absolute left-1/2 transform -translate-x-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-[#4A90A4]/50 to-transparent hidden lg:block" />

          <div className="space-y-12 lg:space-y-0">
            {steps.map((step, index) => (
              <div
                key={index}
                className={`group relative flex flex-col lg:flex-row items-center gap-8 lg:gap-16 ${index % 2 === 1 ? 'lg:flex-row-reverse' : ''}`}
              >
                {/* Step Number Circle */}
                <div className="absolute left-1/2 transform -translate-x-1/2 z-20 hidden lg:flex">
                  <div className="w-16 h-16 bg-black border-2 border-[#4A90A4] flex items-center justify-center group-hover:bg-[#4A90A4] transition-all duration-500">
                    <span className="text-[#4A90A4] text-xl font-bold group-hover:text-white transition-colors duration-500">
                      {step.step}
                    </span>
                  </div>
                </div>

                {/* Content Card */}
                <div className={`flex-1 ${index % 2 === 1 ? 'lg:text-right' : ''}`}>
                  <div className="bg-white/[0.02] border border-white/10 p-8 lg:p-10 group-hover:border-[#4A90A4]/30 group-hover:bg-[#4A90A4]/5 transition-all duration-500">
                    <div className="lg:hidden w-12 h-12 bg-[#4A90A4] flex items-center justify-center mb-6">
                      <span className="text-white text-lg font-bold">{step.step}</span>
                    </div>
                    <h3 className="text-2xl font-semibold text-white mb-4 group-hover:text-[#4A90A4] transition-colors duration-300">
                      {step.title}
                    </h3>
                    <p className="text-white/60 leading-relaxed text-lg">
                      {step.description}
                    </p>
                  </div>
                </div>

                {/* Spacer for alternating layout */}
                <div className="flex-1 hidden lg:block" />
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-20">
          <a
            href="#contact"
            className="group inline-flex items-center gap-3 bg-[#4A90A4] text-white px-8 py-4 font-medium hover:bg-[#5BA0B4] transition-all duration-300 hover:shadow-lg hover:shadow-[#4A90A4]/25"
          >
            Start Your Journey
            <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform duration-300" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
